export default {
      id: "231,8=1,7+70+60+70+28,4+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#231,8=1,7+70+60+70+28,4+1,7",
      toString: function () {
        return this.url;
      }
    }